// extracted by mini-css-extract-plugin
export const root = "BannerMessage-module--root--1ZyZT";
export const content = "BannerMessage-module--content--1WFRG";
export const message = "BannerMessage-module--message--2eDKQ";
export const container = "BannerMessage-module--container--2hCf6";
export const peopleIcon = "BannerMessage-module--people-icon--3ni29";
export const expandLabel = "BannerMessage-module--expand-label--2ja6V";